module.exports = __webpack_public_path__ + "static/media/Car.3945c400.svg";